import { MediaResolver, ResolvedMedia, ResolverContext } from '../types';
import { extractVideoSources, toAbsoluteUrl } from '../utils/htmlMeta';

export class HtmlVideoResolver implements MediaResolver {
  name = 'HtmlVideoResolver';

  async canResolve(context: ResolverContext): Promise<boolean> {
    try {
      const content = await context.fetchContent(context.input.url);

      if (!content.html) {
        return false;
      }

      return /<video[\s>]/i.test(content.html) || extractVideoSources(content.html).length > 0;
    } catch {
      return false;
    }
  }

  async resolve(context: ResolverContext): Promise<ResolvedMedia | null> {
    const content = await context.fetchContent(context.input.url);

    if (!content.html) {
      return null;
    }

    const sources = extractVideoSources(content.html);

    if (!sources.length) {
      return null;
    }

    return {
      mediaType: 'video',
      playerType: 'html5',
      playbackUrl: toAbsoluteUrl(sources[0], content.finalUrl),
      thumbnailUrl: context.input.thumbnailUrl ?? undefined,
      title: context.input.title ?? undefined,
      resolved: true,
      resolverName: this.name,
      metadata: {
        alternateSources: sources.slice(1).map(source => toAbsoluteUrl(source, content.finalUrl)),
      },
    };
  }
}
